import React from "react";
import styles from "./styles.module.scss";

const CircularProgressIndicator = () => {
  return (
    <div className={styles.spinnerWrapper}>
      <div className={styles.spinner}></div>
    </div>
  );
};

export default CircularProgressIndicator;